import { api, ApiResponse } from './api';

export interface Column {
  id: string;
  workspace_id: string;
  name: string;
  description?: string;
  slug: string;
  color?: string;
  sort_order: number;
  auto_kill_days?: number;
  is_active: boolean;
  is_default: boolean;
  created_at: string;
  updated_at: string;
}

export interface CreateColumnData {
  name: string;
  description?: string;
  slug?: string;
  color?: string;
  sort_order?: number;
  auto_kill_days?: number | null;
}

export interface UpdateColumnData {
  name?: string;
  description?: string;
  color?: string;
  sort_order?: number;
  auto_kill_days?: number | null;
  is_active?: boolean;
}

export const columnApi = {
  getAll: async (workspaceId: string, includeHidden = false): Promise<Column[]> => {
    const params = includeHidden ? '?include_hidden=1' : '';
    const response = await api.get<ApiResponse<Column[]>>(`/api/v1/workspaces/${workspaceId}/columns${params}`);
    return response.data.data || [];
  },

  create: async (workspaceId: string, data: CreateColumnData): Promise<Column> => {
    const response = await api.post<ApiResponse<Column>>(`/api/v1/workspaces/${workspaceId}/columns`, data);
    return response.data.data!;
  },

  update: async (workspaceId: string, id: string, data: UpdateColumnData): Promise<Column> => {
    const response = await api.patch<ApiResponse<Column>>(`/api/v1/workspaces/${workspaceId}/columns/${id}`, data);
    return response.data.data!;
  },

  reorder: async (workspaceId: string, order: string[]): Promise<Column[]> => {
    const response = await api.post<ApiResponse<Column[]>>(`/api/v1/workspaces/${workspaceId}/columns/reorder`, { order });
    return response.data.data || [];
  },

  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/api/v1/workspaces/${workspaceId}/columns/${id}`);
  },
};
